export default "__VITE_ASSET__DitSITmI__"